import React from 'react'
import { Card, CardContent, CardHeader, Label, Switch } from '@/shared/ui'
import { useToast } from '@/shared/ui/Toast'
import { getOpportunityPublishInfoMemberVisible, setOpportunityPublishInfoMemberVisible } from '../services/opportunityPublishInfoService'

export default function OpportunityPublishInfoSetting() {
  const [loading, setLoading] = React.useState(true)
  const [saving, setSaving] = React.useState(false)
  const [enabled, setEnabled] = React.useState(false)
  const { add: toast } = useToast()

  React.useEffect(() => {
    let mounted = true
    getOpportunityPublishInfoMemberVisible()
      .then((on) => { if (mounted) setEnabled(on) })
      .catch((e) => toast({ title: 'Oportunidades — Publicado em', description: e?.message || 'Falha ao carregar', variant: 'error' }))
      .finally(() => { if (mounted) setLoading(false) })
    return () => { mounted = false }
  }, [])

  async function handleToggle(next: boolean) {
    if (saving) return
    setSaving(true)
    try {
      await setOpportunityPublishInfoMemberVisible(next)
      setEnabled(next)
      toast({ title: 'Oportunidades — Publicado em', description: next ? 'Visível para membros' : 'Oculto para membros', variant: 'success', soft: true })
    } catch (e: any) {
      toast({ title: 'Oportunidades — Publicado em', description: e?.message || 'Falha ao salvar', variant: 'error' })
    } finally {
      setSaving(false)
    }
  }

  return (
    <Card>
      <CardHeader className="text-base font-semibold">Oportunidades — “Publicado em” (visibilidade para Membros)</CardHeader>
      <CardContent>
        <div className="flex items-center justify-between gap-4 text-sm text-foreground/80">
          <div>
            Quando ativado, o horário de publicação da oportunidade será exibido para usuários não-master. Quando desativado, apenas o master visualiza.
          </div>
          <div className="flex items-center gap-2">
            <Label>Oculto</Label>
            <Switch checked={enabled} onChange={(e)=> handleToggle((e.target as HTMLInputElement).checked)} disabled={loading || saving} />
            <Label>Visível</Label>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

